import React, { useEffect, useState } from "react";

import { getMediaUrl } from "../utils/functions";
import defaultImage from "../assets/images/default_image.svg";

import "../assets/styles/media-frame/media-frame.scss";

const FallbackImage = ({
  paths = [],
  src,
  fallback = defaultImage,
  alt = "",
  className = "",
  frameClassName = "",
  variant = "fill",
  ...props
}) => {
  const resolvedSrc = src || getMediaUrl(...paths) || fallback;
  const [imgSrc, setImgSrc] = useState(resolvedSrc);
  const isFallback = imgSrc === fallback;

  useEffect(() => {
    setImgSrc(resolvedSrc);
  }, [resolvedSrc]);

  const handleError = () => {
    if (imgSrc !== fallback) {
      setImgSrc(fallback);
    }
  };

  return (
    <div
      className={`media-frame media-frame--${variant} ${frameClassName}`.trim()}
    >
      <img
        src={imgSrc}
        alt={alt}
        className={`media-frame__image ${
          isFallback ? "media-frame__image--contain" : ""
        } ${className}`.trim()}
        onError={handleError}
        {...props}
      />
    </div>
  );
};

export default FallbackImage;
